<template>
  <div class="box">
    <el-card :style="{'background-color': '#FAFAFA'}"
             class="el-card-box-t ">
      <p :style="{'--pColor': pColor}"><span>年龄：</span>{{getAgeTime}}<span>角色：</span>{{role}}</p>
      <p :style="{'--pColor': pColor}"><span>出生日期：</span>{{birthday}}</p>
      <p :style="{'--pColor': pColor}"><span>总年数：</span>{{getPastYear}}岁<span>总月数：</span>{{getPastMonth}}个月</p>
      <p :style="{'--pColor': pColor}"><span>总天数：</span>{{getPastDay}}天<span>总小时：</span>{{getPastHour}}小时</p>
      <p :style="{'--pColor': pColor}"><span>总分数：</span>{{getPastMinutes}}分<span>总秒数：</span>{{getPastSeconds}}秒</p>
      <div :class="bg"></div>
    </el-card>
  </div>
</template>
<script>
import { getRemainingTime } from "@/lib/utils"
export default {
  name: "birthTime",
  data() {
    return {
      // birthday: "2021-02-23",
      // birthday: "1990-08-30",
      time: "",
    };
  },
  props: {
    role: {
      type: String,
      default: "",
    },
    birthday: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#ffffff",
    },
    pColor: {
      type: String,
      default: "red",
    },
  },
  mounted() {
    // 开启时间戳的定时，在computed中计算想要的时间
    setInterval(() => this.getCurrentTime(), 1000);
    console.log(this.color);
  },
  computed: {
    getAgeTime() {
      return getRemainingTime(this.time, this.birthday)
    },
    // 当前时间减去出生时间
    getPastSeconds() {
      return parseInt((this.time - +new Date(this.birthday)) / 1000);
    },
    getPastMinutes() {
      return parseInt(this.getPastSeconds / 60);
    },
    getPastHour() {
      return parseInt(this.getPastMinutes / 60);
    },
    getPastDay() {
      return parseInt(this.getPastHour / 24);
    },
    getPastMonth() {
      let months = "";
      let nowYear = new Date(this.time).getFullYear();
      let pastYear = new Date(this.birthday).getFullYear();
      months = (nowYear - pastYear) * 12;
      let nowMonth = new Date(this.time).getMonth() + 1;
      let pastMonth = new Date(this.birthday).getMonth() + 1;
      let diff = nowMonth - pastMonth;
      months = months + diff;
      return months;
    },
    getPastYear() {
      let nowYear = new Date(this.time).getFullYear();
      let pastYear = new Date(this.birthday).getFullYear();
      return nowYear - pastYear;
    },
    bg() {
      if (this.birthday === "2021-02-23") {
        return "el-card-box-tangdou";
      } else if (this.birthday === "1994-04-17") {
        return "el-card-box-guan";
      } else {
        return "";
      }
    },
  },
  methods: {
    getCurrentTime() {
      this.time = +new Date();
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  /* width: 300px; */
  height: auto;
  margin-top: 20px;
  .el-card-box-t {
    position: relative;
  }
  .el-card-box-tangdou {
    content: "";
    // background: url("http://wsjls.site/source/tangdou.jpg") no-repeat;
    background-size: cover;
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 1;
  }
  // .el-card-box-guan {
  //   content: "";
  //   background: url("http://wsjls.site/source/tangdou.jpg") no-repeat;
  //   background-size: cover;
  //   opacity: 0.4;
  //   top: 0;
  //   left: 0;
  //   bottom: 0;
  //   right: 0;
  //   position: absolute;
  //   z-index: 1;
  // }
  p {
    color: var(--pColor);
    span {
      display: inline-block;
      width: 80px;
      text-align: right;
      color: var(--pColor);
    }
  }
}
</style>